var map = {
	"./default.png": 1078,
	"./goodmate.png": 1079,
	"./greenleaf.png": 1080,
	"./pacman.png": 1081,
	"./recette.png": 1082,
	"./thermopi.jpg": 1083,
	"./vierve.png": 1084
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1077;


//////////////////
// WEBPACK FOOTER
// ./src/res/entries ^\.\/.*$
// module id = 1077
// module chunks = 0